
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"32","cy":"32","r":"6"}}),_c('path',{attrs:{"d":"M26 42H10v-4h16z"}}),_c('path',{attrs:{"d":"M26 54h-4V38h4z"}}),_c('path',{attrs:{"d":"M23.646 43.419L10.918 56.146 8.09 53.318 20.818 40.59z"}}),_c('g',[_c('path',{attrs:{"d":"M54.556 26h-16v-4h16z"}}),_c('path',{attrs:{"d":"M42.556 26h-4V10h4z"}}),_c('path',{attrs:{"d":"M56.556 11.272L43.83 24 41 21.172 53.728 8.444z"}})])])])
          )
        }
      }
    